/* eslint-disable camelcase */
import { AccordionItem, AccordionButton, AccordionPanel } from '@uswitch/spark.accordion'
import ImgixImage from '../../elements/imgix-img'

import { useBrand, useEntity, useTracking } from '@uswitch/ev-utils/lib/context/selectors'
import { RichText } from '@uswitch/ev-core/react'
import { accordionStylePath } from './index'
import { TruCaret } from '@uswitch/spark-icons/tru'

export default ({ index, itemIndex, entity, accordionName, variant, extraPadding }) => {
  const brand = useBrand()
  const track = useTracking()
  const { content, title, name: item_name, icon } = useEntity(entity)
  const iconImage = useEntity(icon)
  const trackProps = {
    org_brand: brand,
    name: accordionName,
    item_index: itemIndex,
    item_name,
  }

  const iconElement = ({ isOpen, ...props }) => (
    <TruCaret
      size={16}
      data-ev-accordion
      sx={{
        variant: accordionStylePath('icon', variant),
        transform: isOpen ? 'none' : 'rotate(0.5turn)',
        pointerEvents: 'none',
      }}
      {...props}
    />
  )

  return (
    <AccordionItem
      onOpen={() => track('Accordion Opened', trackProps)}
      onClose={() => track('Accordion Closed', trackProps)}
    >
      <AccordionButton
        sx={{
          variant: accordionStylePath('sectionTitle', variant),
        }}
        iconElement={brand === 'money' ? iconElement : undefined}
        extraPadding={extraPadding}
      >
        <If condition={iconImage?.file?.url}>
          <ImgixImage src={iconImage.file.url} sx={{ marginRight: 12 }} alt={title} />
        </If>
        {title}
      </AccordionButton>
      <AccordionPanel>
        <RichText content={content} />
      </AccordionPanel>
    </AccordionItem>
  )
}
